import React, { useState } from "react";
import { useSessionContext } from "supertokens-auth-react/recipe/session";

import {
    useAddPaymentCommentMutation,
    useGetPaymentCommentsQuery,
    useUpdatePaymentReminderMutation,
} from "../../../services/paymentComments";
import { debounceTextClassNameSmall } from "../../../helpers/debounceTextClassName";
import { getHighlightTextParts } from "./helpers/highlightText";

import { Col, InputGroup, Row } from "react-bootstrap";
import { Hint } from "@progress/kendo-react-labels";

import { Dialog } from "@progress/kendo-react-dialogs";
import { TextArea } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { DatePicker } from "@progress/kendo-react-dateinputs";

import ReactTimeAgo from "react-time-ago";

import { DebounceInput } from "react-debounce-input";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faX } from "@fortawesome/free-solid-svg-icons";

import OtherAvatar from "../../components/OtherAvatar";
import UserAvatar from "../../components/UserAvatar";
import DotLottie from "../../components/DotLottie";

import "./css/MissingStatus.css";

const MissingDialog = ({ toggle, id = null, dataItem = {} }) => {
    const { data = [], isLoading, isFetching } = useGetPaymentCommentsQuery(id, { skip: !id });
    const loading = isLoading || isFetching;

    const [addPaymentComment] = useAddPaymentCommentMutation();
    const [updatePaymentReminder] = useUpdatePaymentReminderMutation();

    const { accessTokenPayload = { userName: "" } } = useSessionContext();
    const { userName = "" } = accessTokenPayload;

    const [text, setText] = useState("");
    const [search, setSearch] = useState("");

    const handleClose = () => {
        toggle();
    };

    const handleSearch = (event) => {
        setSearch(event.target.value);
    };

    const isValidDate = (date) => {
        if (!date || isNaN(date.getTime())) {
            return false; // Ensure it's a valid date object
        }
        const year = date.getFullYear();
        return year >= 1000 && year <= 9999; // Ensure the year has 4 digits
    };

    const handleReminder = async (event) => {
        try {
            const date = event.value;
            if (date === null || isValidDate(date)) {
                await updatePaymentReminder({ id, date, userName });
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            if (!text) {
                return;
            }

            const newComment = {
                ScheduleId: dataItem.ScheduleId,
                PropertyId: dataItem.PropertyId,
                ContractId: dataItem.ContractId,
                StartDate: dataItem.ExpectedPaymentStartDate,
                EndDate: dataItem.ExpectedPaymentEndDate,
                Comment: text,
                CommentKey: id,
                UserName: userName,
            };

            await addPaymentComment(newComment);
            setText("");
        } catch (error) {
            console.log(error);
        }
    };

    const filteredData = search
        ? data.filter((comment) => comment.comment.toLowerCase().includes(search.toLowerCase()))
        : data;

    // const reminderDate = data?.[0]?.reminderDate ? preventTimeZoneDate(data?.[0]?.reminderDate) : null;
    const reminderDate = data?.[0]?.reminderDate;

    return (
        <Dialog title={"Comments"} onClose={handleClose} width={"33vw"} height={"80vh"} className="missing-status-cell">
            <div style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "white", padding: "5px" }}>
                <form onSubmit={handleSubmit}>
                    <div
                        className="d-inline-block editable-date my-1"
                        style={{ background: "#FAF9F6", borderRadius: "10px", padding: "5px", width: "98%" }}
                    >
                        <Row className="align-items-center">
                            <Col lg={2}>
                                <UserAvatar className="user-avatar-small" />
                            </Col>
                            <Col className="d-flex flex-column">
                                <div className="d-flex" style={{ fontSize: "10px" }}>
                                    <Hint className="me-3">
                                        {new Date().toLocaleString("en-US", {
                                            year: "numeric",
                                            month: "numeric",
                                            day: "numeric",
                                        })}
                                    </Hint>
                                </div>
                                <TextArea
                                    style={{ fontSize: "12px" }}
                                    className="my-2"
                                    resizable="none"
                                    rows={3}
                                    value={text}
                                    onChange={(e) => setText(e.target.value)}
                                />
                                <div className="ms-auto">
                                    <Button size="small" style={{ fontSize: "0.75em" }} type="submit">
                                        Add Comment
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </form>
                <hr style={{ flexGrow: 1, color: "lightgray", margin: 0 }} />
                <div className="d-flex flex-column">
                    <div className="d-flex align-items-center mt-2 mb-1">
                        <span className="text-muted text-muted-small" style={{ fontSize: "12px" }}>
                            Reminder
                        </span>
                        <div className="ms-auto d-flex flex-row">
                            <DatePicker
                                value={reminderDate}
                                size="small"
                                onChange={handleReminder}
                                min={new Date(2000, 1, 1)}
                                focusedDate={new Date()}
                            />
                            <Button
                                onClick={() => handleReminder({ value: null })}
                                size="small"
                                className="ms-3"
                                fillMode="flat"
                            >
                                <FontAwesomeIcon icon={faX} size="sm" />
                            </Button>
                        </div>
                    </div>
                    <Hint className="ms-auto me-5">The reminder is shared across all users.</Hint>
                </div>

                <hr style={{ flexGrow: 1, color: "lightgray", margin: 0 }} />
                <InputGroup className="mt-2" style={{ flexWrap: "nowrap" }}>
                    <InputGroup.Text>
                        <FontAwesomeIcon icon={faSearch} />
                    </InputGroup.Text>
                    <DebounceInput
                        placeholder="Search comments"
                        type="search"
                        onChange={handleSearch}
                        debounceTimeout={250}
                        className={debounceTextClassNameSmall}
                        value={search}
                    />
                </InputGroup>
            </div>
            {loading ? (
                <div className="d-flex justify-content-center align-items-center flex-column h-50">
                    <DotLottie
                        src="https://asm-static-files.s3.amazonaws.com/colorful-loading-spinner.lottie"
                        autoplay
                        style={{ width: 125, height: 125 }}
                        loop={true}
                    />
                </div>
            ) : (
                <>
                    {filteredData.map((comment, index) => {
                        const fromUser = comment.fromUser ?? false;
                        const date = new Date(comment.date);
                        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

                        const { escapedSearchTerm, parts } = getHighlightTextParts({
                            text: comment.comment,
                            search: search,
                        });

                        return (
                            <div
                                className="d-inline-block editable-date my-2"
                                style={{ background: "#FAF9F6", borderRadius: "10px", padding: "5px", width: "98%" }}
                                key={`${index}-${comment.date}`}
                            >
                                <Row className="align-items-center">
                                    <Col lg={2}>
                                        {fromUser ? (
                                            <UserAvatar name={comment.userName} className="user-avatar-small" />
                                        ) : (
                                            <OtherAvatar name={comment.userName} className="user-avatar-small" />
                                        )}
                                    </Col>
                                    <Col className="d-flex flex-column">
                                        <div className="d-flex" style={{ fontSize: "10px" }}>
                                            <Hint className="me-3">
                                                {new Date(comment.date).toLocaleString("en-US", {
                                                    timeZone: "UTC",
                                                    year: "numeric",
                                                    month: "numeric",
                                                    day: "numeric",
                                                    hour: "numeric",
                                                    minute: "numeric",
                                                })}
                                            </Hint>
                                            <ReactTimeAgo date={utcDate} locale="en-US" className="ms-auto" />
                                        </div>
                                        <div style={{ fontSize: "12px", wordBreak: "break-word" }} className="my-1">
                                            {search ? (
                                                <>
                                                    {parts.map((part, index) =>
                                                        part?.toLowerCase() === escapedSearchTerm?.toLowerCase() ? (
                                                            <mark key={index}>{part}</mark>
                                                        ) : (
                                                            part
                                                        )
                                                    )}
                                                </>
                                            ) : (
                                                comment.comment
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        );
                    })}
                </>
            )}
        </Dialog>
    );
};

export default MissingDialog;
